// action strings
export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const FETCH_ERROR = 'FETCH_ERROR';
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const TOGGLE_APP_DRAWER = 'TOGGLE_APP_DRAWER';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export const SHOW_WARNING = 'SHOW_WARNING';

export interface FetchSuccessAction {
  type: typeof FETCH_SUCCESS;
}

export interface FetchErrorAction {
  type: typeof FETCH_ERROR;
  error: string;
}

export interface ShowMessageAction {
  type: typeof SHOW_MESSAGE;
  message: string;
}

export interface ToggleDrawerAction {
  type: typeof TOGGLE_APP_DRAWER;
}

export interface HideMessageAction {
  type: typeof HIDE_MESSAGE;
}

export interface CloseSnackbar {
  type: typeof CLOSE_SNACKBAR;
  payload: number;
}

export interface ShowWarningAction {
  type: typeof SHOW_WARNING;
  message: string;
}

export type CommonActionTypes =
  | FetchSuccessAction
  | FetchErrorAction
  | ShowMessageAction
  | ToggleDrawerAction
  | HideMessageAction
  | CloseSnackbar
  | ShowWarningAction;
